const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const formatDate = (value) => {
  if (!value) return "-";
  const [year, month, day] = String(value).split("-");
  if (!year || !month || !day) return value;
  return `${day}/${month}/${year}`;
};

export const formatDateRange = (start, end) => {
  if (!start) return "-";
  if (!end || end === start) return formatDate(start);
  return `${formatDate(start)} - ${formatDate(end)}`;
};

// Cada evento do Teamwork é expandido no backend num registo por dia
// (mesmo teamwork_id/motive/schedule/proof para todos os dias desse
// evento — ver services/api/backend/views/internal_management.py). Dias
// literalmente seguidos com essa mesma combinação pertencem sempre ao
// mesmo evento, por isso podem ser fundidos numa única linha com um
// intervalo de datas sem risco de juntar dois eventos distintos.
export const groupConsecutiveAbsences = (absences) => {
  const groups = new Map();
  (absences || []).forEach((absence) => {
    const key = `${absence.teamwork_id}|${absence.motive}|${absence.schedule}|${absence.proof}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(absence);
  });

  const merged = [];
  groups.forEach((entries) => {
    const sorted = [...entries].sort((a, b) =>
      String(a.date).localeCompare(String(b.date))
    );
    let block = null;
    sorted.forEach((entry) => {
      const entryTime = new Date(`${entry.date}T00:00:00`).getTime();
      if (block && entryTime - block.endTime === ONE_DAY_MS) {
        block.end = entry.date;
        block.endTime = entryTime;
      } else {
        if (block) merged.push(block);
        block = {
          ...entry,
          id: `${entry.teamwork_id}-${entry.date}`,
          start: entry.date,
          end: entry.date,
          endTime: entryTime,
        };
      }
    });
    if (block) merged.push(block);
  });

  return merged.sort((a, b) => {
    const dateA = String(a.start || "");
    const dateB = String(b.start || "");
    if (dateA !== dateB) return dateA.localeCompare(dateB);
    const nameA = `${a.first_name || ""} ${a.last_name || ""}`.trim();
    const nameB = `${b.first_name || ""} ${b.last_name || ""}`.trim();
    return nameA.localeCompare(nameB, "pt");
  });
};
